mutation CompleteAdminFeeSageJournalEntry($id: ID!) {
  completeAdminFeeSageJournalEntry(input: { id: $id }) {
    success
  }
}
